<template>
    <div id="app">
        <router-view/>
<!--        <loading ></loading>-->
    </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import user from "./api/user";
// import Loading from "./components/Loading";

export default {
    name: 'App',
    // components: {Loading},
    data(){
        return {

        }
    },
    created () {
        this.init()
    },
    computed:{
        ...mapGetters({
            getUser : 'getUser',
        }),
    },

    methods: {
        ...mapMutations({
            setUser : 'setUser',
        }),
        init(){
            let token = localStorage.getItem('token')
            if (token){
                user.info().then(res => {
                    if (res.code === 200){
                        localStorage.setItem('token', res.data.token)
                        this.setUser(res.data)
                    }
                })
            }else {
                console.log('this.$route',this.$route.name)
                if (this.$route.name !== 'Login'){
                    this.$router.push({name : "Login"})
                }
            }
        }
    }
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*background: #eee;*/
    /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue